<form (ngSubmit)="onSubmit()" [formGroup]="formGroup" #form="ngForm">
  <div class="row mt-2">
    <div class="col">
      <mat-form-field>
        <input matInput formControlName="logoUrl" placeholder="{{ 'forms.cloudConfiguration.labels.logoUrl' | translate }}" />
        <mat-error>{{ getError("logoUrl") }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <mat-form-field>
        <input matInput formControlName="backgroundUrl" placeholder="{{ 'forms.cloudConfiguration.labels.backgroundUrl' | translate }}" />
        <mat-error>{{ getError("backgroundUrl") }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ "forms.cloudConfiguration.labels.productionMeters" | translate }}</mat-label>
        <mat-select formControlName="productionMeterId" multiple>
          <mat-option *ngFor="let meter of meters" [value]="meter.id">{{ meter.name }}</mat-option>
        </mat-select>
        <mat-error>{{ getError("productionMeterId") }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ "forms.cloudConfiguration.labels.consumptionMeters" | translate }}</mat-label>
        <mat-select formControlName="consumptionMeterId" multiple>
          <mat-option *ngFor="let meter of meters" [value]="meter.id">{{ meter.name }}</mat-option>
        </mat-select>
        <mat-error>{{ getError("consumptionMeterId") }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <ng-container *ngFor="let zoneGroupGroup of getFormArrayGroups('zoneGroups'); let i = index; let length = count">
    <div [formGroup]="zoneGroupGroup">
      <div class="row mt-2">
        <div class="col-auto">
          <div class="order-buttons">
            <button mat-icon-button type="button" color="primary" [disabled]="i <= 1" (click)="moveFormArrayItem('zoneGroups', i, i - 1)">
              <mat-icon>expand_less</mat-icon>
            </button>
            <button mat-icon-button type="button" color="primary" [disabled]="i === 0 || i === length - 1" (click)="moveFormArrayItem('zoneGroups', i, i + 1)">
              <mat-icon>expand_more</mat-icon>
            </button>
          </div>
        </div>
        <div class="col">
          <mat-form-field>
            <input matInput formControlName="name" placeholder="{{ 'forms.cloudConfiguration.labels.name' | translate }}" />
            <mat-error>{{ getError("name", zoneGroupGroup) }}</mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="!zoneGroupGroup.value.dashboard" class="col">
          <mat-form-field>
            <mat-label>{{ "forms.cloudConfiguration.labels.zones" | translate }}</mat-label>
            <mat-select formControlName="zones" multiple>
              <mat-option *ngFor="let zone of zones" [value]="zone.id">{{ zone.name }}</mat-option>
            </mat-select>
            <mat-error>{{ getError("zones", zoneGroupGroup) }}</mat-error>
          </mat-form-field>
        </div>
        <div class="col-auto">
          <button mat-icon-button color="primary" [disabled]="zoneGroupGroup.value.dashboard" (click)="removeFormArrayItem('zoneGroups', i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="row justify-content-center mt-2">
    <div class="col-md-auto">
      <button mat-stroked-button color="primary" (click)="addFormArrayItem('zoneGroups')">
        {{ "forms.cloudConfiguration.buttons.addGroup" | translate }}
      </button>
    </div>
  </div>
  <div *ngIf="withSubmit" class="row justify-content-end mt-2">
    <div class="col-md-auto">
      <button mat-raised-button [appButtonLoading]="formLoading.loading" color="primary">
        {{ submitText | translate }}
      </button>
    </div>
  </div>
</form>
